





















import Vue from 'vue';

export default Vue.extend({
  props: {
    prop: {
      type: Object,
      default: null,
    },
    isBottom: {
      type: Boolean,
      default: true,
    },
    isTop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultValue: null,
    };
  },
  methods: {
    confirmProp() {
      if (!this.defaultValue || this.defaultValue.length === 0) {
        this.$Message.error('请设置默认值');
      } else {
        this.$emit('setProp', {prop: this.prop, defaultValue: this.defaultValue});
        this.defaultValue = null;
      }
    },
  },
});
